import * as THREE from 'three'
import { useRoof } from '../../../../hooks/state/useRoof'
import { CachedMeshPhysicalMaterial } from '../../../material/cachedMeshPhysicalMaterial'
import { RoundedBox } from '@react-three/drei'
interface Props {
  marqueeWidth: any
  position: [number, number, number]
  rotation: [number, number, number]
}

export const RoundMarquee = ({
  marqueeWidth,
  position,
  rotation,
}: Props): JSX.Element => {
  const { color } = useRoof()

  const casing = {
    radius: 0.05,
    width: marqueeWidth,
  }

  const casingRail = {
    width: casing.radius * 2,
    height: casing.radius,
    length: marqueeWidth - 0.001,
  }

  const casingGeometry = new THREE.CylinderGeometry(
    casing.radius,
    casing.radius,
    casing.width,
    32
  )

  return (
    <group position={position} rotation={rotation} castShadow receiveShadow>
      <mesh geometry={casingGeometry} castShadow receiveShadow>
        <CachedMeshPhysicalMaterial color={color} />
      </mesh>

      <RoundedBox
        args={[casingRail.height, casingRail.length, casingRail.width]}
        position={[
          casing.radius - casingRail.height / 2,
          0,
          -casingRail.width / 2,
        ]}
        radius={0.001}
        castShadow
        receiveShadow
      >
        <CachedMeshPhysicalMaterial color={color} />
      </RoundedBox>
    </group>
  )
}
